/**
 * JSONP - https://stackoverflow.com/a/2067584
 * 
 * This function simply takes a URL and embeds it on the page as a script.
 * 
 * In short, this is a really old workaround for cross-domain ajax requests (that was replaced by CORS in like 2014...).
 * There are security vulnerabilites of this method so you MUST trust the target server.
 * 
 * 
 * DotDigital don't have a way of allowing fetch requests because of their CORS policy (or lack of).
 * Instead they have a JSON endpoint that can take an optional callback parameter.
 * If this parameter is present it instead returns the JSON as a function instead of a datasource, e.g:
 * 
 * JSON: {data: 'example'}
 * FUNCTION: jsonp1234({data: 'example'});
 * 
 * The below function embeds the JSON endpiint as a script and then returns this function.
 */
function jsonp(url, callback) {
    var callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
    window[callbackName] = function(data) {
        delete window[callbackName];
        document.body.removeChild(script);
        callback(data);
    };

    var script = document.createElement('script');
    script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
    document.body.appendChild(script);
}


const campaignFeedEls = document.getElementsByClassName('c-campaign_feed');

if( campaignFeedEls.length ) {

   const toShow = 4;
   const url = `https://visitjersey.email/RssCampaignFeed?output=2&uid=75II&cid=6CE8FB29DF09557017YTG05FB9D0872210E542&tagname=&count=${toShow}&showdate=true&fid=dmfeed_00d7619d-c4d3-abd5-6b9c-864dc0221996`;
   

   Array.from(campaignFeedEls).forEach( (feedEl) => {
      jsonp(url, (data) => {

         const items = data.items ? data.items : null;

         if( feedEl && items ) {
            let html = "";

            items.forEach(item => {
               html += `
                  <li class="flex flex-col py-[15px] text-16 border-b border-[#CCC]">
                     <span class="text-14 mb-5">${item.DateSent}</span>
                     <a href="${item.CantReadUrl}" target="_blank" rel="noopener">${item.Name}</a>
                  </li>
               `
            });

            feedEl.innerHTML = `
               <ul class="list-reset border-t border-[#CCC]">
                  ${html}
               </ul>
            `;
         }
      });

   });

   

}